import { ChangeStatusMessage, ReadAllConversationsResponse } from '@core/definitions/api/chat.definitions';
import { Conversation, ReciveNewMessage } from '../chat.definitions';
export class ChatUpdateConversationAction {
  static readonly type = '[CHAT] UPDATE_CONVERSATION';
  constructor(public conversation: Conversation) {
  }
}
export class ChatSelectConversationAction {
  static readonly type = '[CHAT] SELECT_CONVERSATION';
  constructor(public conversation: Conversation) {
  }
}
export class ChatSetModuleOpenAction {
  static readonly type = '[CHAT] SET_OPEN_MODULE';
  constructor(public isOpen: boolean) {
  }
}
export class ChatSetCurrentUserAction {
  static readonly type = '[CHAT] SET_CURRENT_USER';
  constructor(public user: { user: string, name: string }) {
  }
}
export class ChatSetLoadingModuleAction {
  static readonly type = '[CHAT] SET_LOADING_MODULE';
  constructor(public loading: boolean) {
  }
}
export class ChatFilterConversationsAction {
  static readonly type = '[CHAT] FILTER_CONVERSATIONS';
  constructor(public filter: string, public value: any) {
  }
}
// Recive
export class ChatReciveCreateNewConversationAction {
  static readonly type = '[CHAT] NEW_CONVERSATION_RECIVED';
  constructor(public conversation: Conversation) {
  }
}
export class ChatReciveNewMessageAction {
  static readonly type = '[CHAT] NEW_MESSAGE_RECIVED';
  constructor(public message: ReciveNewMessage) {
  }
}
export class ChatReciveMessagesHasRecivedAction {
  static readonly type = '[CHAT] RECIVE_MESSAGES_HAS_RECIVED';
  constructor(public changeStatus: ChangeStatusMessage) {
  }
}
export class ChatReciveMessagesHasReadedAction {
  static readonly type = '[CHAT] CHANGE_MESSAGE_STATUS_SEND';
  constructor(public changeStatus: ChangeStatusMessage) {
  }
}
// Send
export class ChatSetConversationsAction {
  static readonly type = '[CHAT] SET_CONVERSATIONS';
  constructor(public response: ReadAllConversationsResponse) {
  }
}
export class ChatSendMessagesHasRecivedAction {
  static readonly type = '[CHAT] SEND_MESSAGES_HAS_RECIVED';
}
export class ChatSendMessagesHasReadedAction {
  static readonly type = '[CHAT] SEND_MESSAGES_HAS_READED';
  constructor(public ids: string[]) {
  }
}
export class ChatUpdateUnreadMessagesCountAction {
  static readonly type = '[CHAT] UPDATE_UNREAD_MESSAGES_COUNT';
  constructor(public payload: { conversation: string, count: number }[]) {
  }
}
export class ChatGetMessagesUnreadCountAction {
  static readonly type = '[CHAT] SEND_GET_MESSAGES_UNREAD_COUNT';
  constructor(public unreadMessagesCount: { [key: string]: number }) {
  }
}
export class ChatGetMessagesAction {
  static readonly type = '[CHAT] GET_MESSAGES';
  constructor(public payload: { conversation: string; after: Date, size: number }) {
  }
}
